import { createActionGroup, props } from '@ngrx/store';
import { zefDialogOpen } from '@zerops/zef/dialog';
import { FEATURE_NAME } from './control-plane-dialog.constant';
import {
  ZagentDialogMode,
  ZagentRecipeContext,
  ControlPlaneMiniConfig
} from '../../core/zerops-services/zerops-services.model';

export const controlPlaneDialogActions = createActionGroup({
  source: FEATURE_NAME,
  events: {
    'deploy': props<{ projectId: string; yamlContent: string; createIntegrationToken: boolean }>()
  }
});

/**
 * Optional defaults injected by the caller for the two opt-in feature toggles.
 * Both default to `true` (Coding Agent + Cloud IDE on) when omitted.
 */
export interface ControlPlaneDialogDefaults {
  enableAgent?: boolean;
  enableVscode?: boolean;
}

/**
 * Opens the Control Plane dialog.
 *
 * @param projectId - The project ID (use 'pending' for recipe mode before project creation)
 * @param dialogMode - 'standalone' for existing projects, 'recipe' for recipe deployment flow
 * @param recipeContext - Service context from recipe environment (recipe mode only)
 * @param initialConfig - Initial configuration values (for recipe mode)
 * @param defaults - Per-call default values for the Coding Agent / Cloud IDE toggles
 * @param meta - Additional metadata to pass through dialog lifecycle (e.g., source, recipeSlug)
 */
export const controlPlaneDialogOpen = (
  projectId: string,
  dialogMode: ZagentDialogMode = 'standalone',
  recipeContext?: ZagentRecipeContext,
  initialConfig?: ControlPlaneMiniConfig,
  defaults?: ControlPlaneDialogDefaults,
  meta?: Record<string, any>
) =>
  zefDialogOpen({
    key: FEATURE_NAME,
    meta: { projectId, dialogMode, recipeContext, initialConfig, defaults, ...meta }
  });
